import React from "react";
import { Navigate } from "react-router-dom";
import { getUserDetails } from "../utils/localStorageServices";
import moment from "moment";

export default function ProtectedRoute({ children }) {
  const tokenObject = getUserDetails();
  const tokenExpiry = tokenObject?.expiresIn;
  const token = tokenObject?.token;

  //removing the moment(tokenExpiry).isBefore(
  if (!tokenObject || !token || moment(tokenExpiry).isBefore(moment())) {
    localStorage.clear();
    return <Navigate to={"/login"} replace />;
  } else {
    return children;
  }
}
